<template>
  <!-- 下单冲榜 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <!-- <div class="headReturn" v-if="localStep == 0">
      <span @click="returnBack"> <i class="el-icon-arrow-left"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">{{ activityData.name }}</span>
    </div> -->
    <div :class="{ formBox: localStep != 0 }">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 0">
        <!-- 提示 -->
        <!-- <div class="card-point tipBg">
          <div class="card-rule" style="width: 45px;">注：</div>
          <template v-if="venderType">
            <div class="card-connet" v-if="orderCRM">
              <p>
                1、自营店铺需要搭配<span style="color:#7B61FF;">云短信CRM</span
                >使用,<span
                  style="color:#7B61FF;"
                  @click="handleCreate"
                  class="pointer"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
            <div class="card-connet" v-else>
              <p>
                1、云短信CRM：订购到期时间
                {{ orderCRMtime }}（自营店铺需要搭配<span
                  @click="handleCreate"
                  class="pointer"
                  style="color:#7B61FF;"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
          </template>
          <div class="card-connet" v-else>
            <p>1、订单完成后发放奖励。</p>
          </div>
        </div> -->
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                @click="handleNav(item,index)"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(123,97,255,0.15);"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05);"
                ></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img class="imgs" style="width:100%;" :src="item.imageUrl" alt="" />
                  <img v-if="item.days" class="temImg_content_img_free" src="@/assets/thdImg/common/free.svg" alt="" srcset="" />
                  <div v-if="item.days" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0">
        <div class="card-point tipBg">
          <div class="card-rule">官方规则：</div>
          <template>
            <div class="card-connet" v-if="orderCRM">
              <p>
                1、自营店铺需搭配<span style="color:#7B61FF;">云起云舟</span
                >使用, 详情请咨询客服。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
            <div class="card-connet" v-else>
              <p>
                1、云短信CRM
                {{ orderCRMtime.length > 0 ?'：订购到期时间 ' + orderCRMtime : ''}}（店铺需要搭配<span
                  @click="handleCreate"
                  class="pointer"
                  style="color:#7B61FF;"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </div>
          </template>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="160px"
        >
          <!-- 下单有礼 -->
          <div class="newsInfo">基本信息</div>
          <template>
            <el-form-item label="活动名称:" required>
              <!-- prop="activityName" 活动名称 -->
              <el-input
                v-model="ruleForm.activityName"
                maxlength="15"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 400px"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
              <div class="my_select_time">
                <!-- <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 400px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker> -->
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                  :disabled="activityData.isStart"
                  :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.activityEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  @focus="orderFocus(1)"
                  :picker-options="pickerOptionsValueEnd"
                  :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                  :clearable="false"
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天
                <span style="color: #7B61FF">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
              <div class="act-tip" v-if="isShowEndTip">
                *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
              </div>
            </el-form-item>

            <el-form-item label="活动参与对象:" prop="partner">
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <!-- 去掉非会员的选项 -->
                <!-- <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                > -->
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="item.value"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <span class="memberTips" 
                >注：由于官方规定，会员才可拿到订单数据，因此该活动限定会员参与<br
              /></span>
              <span v-if="localStepNum == 3"
                >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
              >

              <!-- 1.14迭代 下单冲榜 -->
              <div style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime"  :disabled="activityData.isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||activityData.isStart">
                </el-date-picker>
                <i v-if="ruleDto.isCheckOpenCardTime" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span style="color:red">注意：该条件对【非会员】身份不生效</span>
            </el-form-item>

            <!-- 1.14迭代 plus会员限制 -->
            <el-form-item label="Plus会员身份:" required>
              <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="activityData.isStart">不限</el-radio>
              <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="activityData.isStart">Plus会员</el-radio>
              <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="activityData.isStart">非plus会员</el-radio>
              <div style="color:red">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
            </el-form-item>

            <el-form-item label="活动条件:">
              <el-checkbox v-model="ruleForm.condFollow" :disabled="activityData.isStart"
                >关注店铺后方可参与活动</el-checkbox
              ></el-form-item
            >
            <div class="newsInfo">入榜规则</div>
            <el-form-item label="入榜规则:" required>
              <div class="rule_box_top">
                  所下订单需满足如下条件
              </div>
              <div class="rule_box">
                <div class="rule_box_middle">
                  <el-form-item label="开榜时间:" required>
                    <div class="my_select_time">
                      <!-- @change="scoresChange" -->
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.showRankTime"
                        type="datetime"
                        placeholder="选择日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 200px; font-size: 12px"
                        default-time="00:00:00"
                        :clearable="false"
                        :picker-options="scoresOrderStart"
                        :disabled="activityData.isStart"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearScoresTime()"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                    <div style="color: red;font-size: 12px;">
                      注：开榜时间需小于活动结束时间，建议配置早于活动结束时间大于10分钟，活动结束后，用户无法再领取奖品；
                    </div>
                  </el-form-item>
                </div>
                <div class="rule_box_middle">
                  <el-form-item label="下单时间:" required >
                      <div class="my_select_time">
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="ruleForm.orderStartTime"
                          type="datetime"
                          placeholder="开始日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          style="width: 190px; font-size: 12px"
                          default-time="00:00:00"
                          class="time1"
                          @change="orderChange"
                          @focus="orderFocus(2)"
                          :clearable="false"
                          :picker-options="pickerOrderStart"
                        >
                        </el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="ruleForm.orderEndTime"
                          type="datetime"
                          placeholder="结束日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          style="width: 195px; font-size: 12px"
                          default-time="23:59:59"
                          class="time2"
                          @change="orderChange"
                          @focus="orderFocus(2)"
                          :clearable="false"
                          :picker-options="pickerOrderEnd"
                        >
                        </el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          @click="clearOrderTime()"
                        ></i>
                        <img
                          src="@/assets/images/select_date.svg"
                          alt=""
                          class="date_icon2"
                        />
                      </div>
                      <el-tooltip
                        class="item"
                        effect="light"
                        placement="bottom"
                      >
                        <div slot="content">
                          1、订单验证时间不得超过100天<br/>
                          2、用户订单的付款（包括付款、付尾款）时间必须在该时间段内，付款开始时间必须大于活动开   始时间。如果选择订单状态为收货，收货时间可在付款时候之后，活动结束时间之前。
                        </div> 
                        <el-button type="text" style="width: 35px;">
                          <i class="el-icon-question" style="color: #ccc;"></i>
                        </el-button>
                      </el-tooltip>
                      <div class="act-tip" v-if="isShowTip">
                        *提示：修改下单时间活动条件不会改变已参与用户的数据状态，修改仅适用于新用户参与活动的判定
                      </div>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom">
                  <el-form-item label="金额统计类型:" required>
                    <el-radio-group
                      v-model="ruleForm.popOrderStartPaymentType"
                      :disabled="activityData.isStart "
                    >
                      <el-radio :label="1">
                        <span>订单金额（后台价）</span>
                        <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                          <el-button type="text" style="width: auto;">
                            <i class="el-icon-question" style="color: #ccc;"></i>
                          </el-button>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="0" v-if="!venderType">
                        <span>用户应付金额</span>
                        <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                          <el-button type="text" style="width: auto;">
                      <i class="el-icon-question" style="color: #ccc;"></i>
                    </el-button>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="2" v-if="!venderType">
                        <span>用户实付金额</span>
                        <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                          <el-button type="text" style="width: auto;">
                            <i class="el-icon-question" style="color: #ccc;"></i>
                          </el-button>
                        </el-tooltip>
                      </el-radio>
                    </el-radio-group>
                    <div class="memberTips" style="margin-right: 30px;">注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。</div> 
                  </el-form-item>
                </div>
                <div class="rule_box_middle" >
                  <el-form-item label="有效订单金额最小值:" required>
                  <div style="display: flex;">
                  <el-input
                      v-model="ruleForm.minValidAmount"
                      maxlength="15"
                      show-word-limit
                      placeholder="请输入有效订单金额最小值"
                      style="width: 378px"
                      :disabled="activityData.isStart"
                      @input="ruleForm.minValidAmount = getNumberData(1, $event, 1, 0)"
                    ></el-input>
                    <span style="padding-left: 8px;">元</span>
                    <el-tooltip
                      class="item"
                      effect="light"
                      placement="bottom"
                    >
                      <div slot="content">
                        针对单笔订单，用户消费的订单金额需大于设置的有效订单金额最小值才可算入下单累计金额计算中。
                      </div> 
                      <el-button type="text" style="width: 35px;">
                        <i class="el-icon-question" style="color: #ccc;"></i>
                      </el-button>
                    </el-tooltip>
    
                  </div>
                  <!-- <div class="memberTips" style="margin-right: 30px;">注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</div> -->
                  </el-form-item>
                </div>
                <div class="rule_box_middle">
                <el-form-item label="入榜最低金额:" required >
                  <el-input
                      v-model="ruleForm.minRankAmount"
                      maxlength="15"
                      show-word-limit
                      placeholder="请输入入榜最低金额"
                      style="width: 378px"
                      :disabled="activityData.isStart"
                      @input="ruleForm.minRankAmount = getNumberData(1, $event, 1, 0)"
                    ></el-input>
                    <span style="padding-left: 8px;">元</span>
                  </el-form-item>
                </div>
                <div class="rule_box_middle">
                  <el-form-item label="订单类型:">
                    <el-checkbox-group v-model="ruleForm.orderType" :disabled="activityData.isStart">
                      <el-checkbox :label="0">预售订单</el-checkbox>
                      <el-checkbox :label="1">普通订单</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                    <el-radio-group
                      :disabled="activityData.isStart"
                      v-model="ruleForm.mergeOrder"
                    >
                      <el-radio :label="false">否</el-radio>
                      <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                    <el-button type="text" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</el-button>
                  </el-form-item>
                <div class="rule_box_middle">
                  <el-form-item label="订单状态:">
                    <el-select v-model="ruleForm.orderState" placeholder="请选择" :disabled="activityData.isStart"   @change="ruleForm.refundCountFlag = 0">
                    <el-option
                      v-for="item in orderStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="memberTips" style="margin-right: 30px;">注意：下单时间中，用户的订单超过设置的有效金额最小值且满足选择的订单状态才会算入该用户的有效下单金额累计。</div>
                  <div class="memberTips" style="margin-right: 30px;">付尾款或付款：下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）。</div>
                  <div class="memberTips" style="margin-right: 30px;">收货：订单完成后统计订单金额。</div>
                  <div  v-if="ruleForm.orderState == 0">
                      <el-checkbox
                        v-model="ruleForm.refundCountFlag"
                        :true-label="1"
                        :false-label="0"
                        :disabled="activityData.isStart"
                        >退款回退金额</el-checkbox
                      >
                    </div>
                    <div  v-if="ruleForm.orderState == 0"
                      style="margin-right: 30px; color: #666; font-size: 12px"
                    >
                      开启该选项，用户的订单在订单完成前发生退款后会回退相应金额，需要注意如果用户在开榜后退款，不会处理
                    </div>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom">
                  <el-form-item label="指定购买商品:" required >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      :disabled="activityData.isStart"
                      label="0"
                    >
                      全部商品
                    </el-radio>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="activityData.isStart"
                      >指定商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      :disabled="activityData.isStart"
                      >排除商品</el-radio
                    >
                    <el-button
                      class="zindexBox"
                      :disabled="ruleForm.filterType == 0 || activityData.isStart"
                      :style="{
                        width: itemListForFilter.length > 0 ? '110px' : '60px',
                      }"
                      @click="exposureProductsFiter"
                    >
                      {{
                        itemListForFilter.length != ""
                          ? "已选择" + "(" + itemListForFilter.length + "个)"
                          : "+添加"
                      }}
                    </el-button>
                  </el-form-item>
                </div>
                <div class="rule_box_bottom">
                  <el-form-item label="金额统计方式:" required>
                    <el-radio
                      v-model="ruleForm.moneyCountType"
                      :disabled="activityData.isStart"
                      :label="0"
                    >
                      累计订单
                    </el-radio>
                    <el-radio
                      class="oneOrder"
                      v-model="ruleForm.moneyCountType"
                      :disabled="activityData.isStart"
                      :label="1"
                    >
                      单笔订单
                    </el-radio>
                    <el-tooltip
                      effect="light"
                      placement="top"
                      popper-class="oneOrder-tooltip"
                    >
                      <div slot="content">
                        累计订单:用户在指定时间内符合条件的订单金额总和;<br/>
                        单笔订单:用户在指定时间内符合条件的最高金额的一笔订单;<br/>
                        入榜限制计算方式跟随金额统计方式
                      </div> 
                      <el-button type="text" style="width: 35px;">
                        <i class="el-icon-question" style="color: #ccc;"></i>
                      </el-button>
                    </el-tooltip>
                  </el-form-item>
                </div>
                <!--TODO:v1.49 限制统计金额的条件 -->
                <div v-if="ruleForm.popOrderStartPaymentType==1&&ruleForm.filterType === '1'" class="rule_box_middle">
                  <!-- <el-form-item label="限制统计金额:" required>
                    <el-radio
                      v-model="ruleForm.limitAmountType"
                      :disabled="activityData.isStart"
                      label="0"
                    >
                      整单统计
                    </el-radio>
                    <el-radio
                      v-model="ruleForm.limitAmountType"
                      :disabled="activityData.isStart"
                      label="1"
                    >
                      仅统计指定SKU
                    </el-radio>
                  </el-form-item> -->
                  <el-form-item label="指定商品规则:">
                    <el-select style="width: 280px;" v-model="ruleForm.limitAmountType" :disabled="activityData.isStart" placeholder="">
                      <el-option label="只要订单包含指定商品就整单计算" value="0"></el-option>
                      <el-option label="仅统计订单内指定商品的金额和件数" value="1"></el-option>
                    </el-select>
                    <el-button type="text" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</el-button>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>

            <div class="newsInfo">名次奖品设置</div>
            <el-form-item label="名次规则:" required >
              <el-radio
                v-model="rulesType"
                :disabled="activityData.isStart"
                :label="0"
              >
                按排名
              </el-radio>
              <el-radio
                v-model="rulesType"
                :label="1"
                :disabled="activityData.isStart"
                >按阶梯</el-radio
              >
            </el-form-item>
            <el-form-item v-if="rulesType == 0" label="名次奖品设置:" required >
              <span>至多添加20个名次，用户可在开榜领取对应名次的奖品。</span>
              <div class="newCard">
                <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit" class="zindexBox">
                  <el-tab-pane
                    :key="item.name"
                    v-for="(item, index) in editableTabs"
                    :label="item.title"
                    :name="item.name"
                  >
                  <div class="prize_box">
                      <el-form-item label="奖品设置:" required label-width="100px">
                        <div>1、至订单完成后发放奖励，整个活动期内每人每个名次只可领取1次及其中一个奖品。</div>
                        <div>2、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</div>
                      </el-form-item>
                      <el-form-item label="最低入榜条件:">
                        <div class="flexc-cen-x" v-if="ruleForm.rankActivityType==0">
                          <span>最低消费</span>
                          <el-input class="w120 mlr8" v-model="item.orderAmtLimit" :disabled="activityData.isStart" @input="item.orderAmtLimit = getNumberData(1, $event, 1, 0)" placeholder="不限"></el-input>
                          <span>元</span>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            content="配置后，需用户满足当前金额才可进入榜单，例用户消费在榜单中最高，但未达到第一名门槛则不排第一名，根据其余满足门槛的最高名次进行排名"
                          >
                            <i class="new-icon-box ml4 mt2"></i>
                          </el-tooltip>
                        </div>
                        <div class="flexc-cen-x" v-else>
                          <span>最低邀请</span>
                          <el-input class="w120 mlr8" v-model="item.successInviteNum" :disabled="activityData.isStart" @input="item.successInviteNum = getNumberData(1, $event, 0, 0)" placeholder="不限"></el-input>
                          <span>人入会</span>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            content="配置后，需用户满足当前邀请人数才可进入榜单，例用户在榜单中邀请人数最高，但未达到第一名门槛则不排第一名，根据其余满足门槛的最高名次进行排名"
                          >
                            <i class="new-icon-box ml4 mt2"></i>
                          </el-tooltip>
                        </div>
                      </el-form-item>
                      <el-table
                        :header-cell-style="{
                          'text-align': 'center',
                          'border-bottom': '2px solid #EBEEF5',
                          background: '#FAFAFA',
                        }"
                        :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
                        :data="item.content"
                        border
                        style="width:900px;overflow: visible;"
                      >
                        <el-table-column prop="date" label="序号" width="110">
                          <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="name" label="奖品类型">
                          <template slot-scope="scope">
                            <div v-if="backgroundOpacity || activityData.isStart">
                              <span
                                style="color: #909399;"
                                v-if="scope.row.prizeType == 3"
                                >{{ scope.row.title }}</span
                              >
                              <span
                                style="color:#909399"
                                v-else-if="scope.row.prizeType"
                                >{{ scope.row.prizeType | prizeType }}</span
                              >
                              <span
                                v-else
                                style="color:#909399"
                                >选择奖品</span
                              >
                            </div>
                            <div v-else>
                              <span
                                style="color:#7F85E9;cursor: pointer;"
                                v-if="scope.row.prizeType == 3"
                                @click="centerVis(scope)"
                                >{{ scope.row.title }}</span
                              >
                              <span
                                v-else-if="scope.row.prizeType == 14"
                                style="color:#909399"
                                >选择奖品</span
                              >
                              <span
                                style="color:#7F85E9;cursor: pointer;"
                                v-else-if="scope.row.prizeType"
                                @click="centerVis(scope)"
                                >{{ scope.row.prizeType | prizeType }}</span
                              >
                              <span
                                v-else
                                @click="centerVis(scope)"
                                style="color:#7B61FF;cursor: pointer;"
                                >选择奖品</span
                              >
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="price" width="110" label="值">
                        </el-table-column>
                        <el-table-column width="145" label="奖品总份数">
                          <template slot-scope="scope">
                            <span v-if="rulesType == 0">{{ scope.row.prizeCount || 1 }}</span>
                            <el-input
                              v-else
                              v-model="scope.row.prizeCount"
                              placeholder="请输入"
                              :disabled="backgroundOpacity || (activityData.isStart && !scope.row.prizeCount) || activityData.isStart"
                              @input.native="
                                (e) =>
                                  (scope.row.prizeCount = checkputn(
                                    e,
                                    scope.row,
                                    'jindou'
                                  ))
                              "
                              @input="scope.row.prizeCount = getNumberData(1, $event, 0, 1),prizeNum(scope.row)"
                              @blur="inputprizeCount(scope,index)"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column prop="logo" width="200" label="奖品展示图片">
                            <template  slot-scope="scope">
                              <div class="btnGroup1">
                                <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;margin-right:10px">
                                <div slot="error" class="image-slot">
                                </div>
                              </el-image>
                                <div v-if="backgroundOpacity || activityData.isStart " class="btnGroup">
                                  <div style="color: #909399;margin-right: 10px;" >上传图片</div>
                                  <div style="color: #909399;" v-if="scope.row.prizeType != 3 ">重置</div>
                                </div>
                                <div v-else class="btnGroup">
                                  <el-upload
                                    class="upload"
                                    action="/jd-hd-web/image/upload"
                                    :show-file-list="false"
                                    :before-upload="beforeUpload2"                     
                                    :on-success=" (file) =>  { return handleUpload2(file, scope)}"
                                    >
                                    <div class="btnGroup_button" style="margin-right: 10px;">上传图片</div>
                                  </el-upload>
                                  <div class="btnGroup_button" @click="picUrlReset2(scope)" v-if="scope.row.prizeType != 3 ">重置</div>
                                </div>
                              </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="200" label="操作">
                            <template  slot-scope="scope">
                              <span style="color: #909399;width:36px" v-if="backgroundOpacity || activityData.isStart">删除</span>
                              <span @click="itemDel(scope.$index)" style="cursor: pointer;color: #FF4B4B;width:36px" v-else>删除</span>
                              <el-button type="text" style="margin-left: 5px" v-if="activityData.isStart && scope.row.title"
                              @click="itemAddNum('',scope.$index)">增加奖品数量</el-button>
                            </template>
                        </el-table-column>
                      </el-table>
                      <div
                        class="add_btn1"
                        style="width: 125px;color: #909399;border: 1px solid #909399;background: rgba(0, 0, 0, 0.1);"
                        v-if="backgroundOpacity || activityData.isStart"
                      >
                        添加奖项（{{ item.content.length }}/4）
                      </div>
                      <div
                        @click="addPrizeRule"
                        class="add_btn1"
                        style="width: 125px;"
                        v-else
                      >
                        添加奖项（{{ item.content.length }}/4）
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form-item>
            <el-form-item v-else label="名次奖品设置:" required>
              <div>规则说明：</div>
              <div>1、如按阶梯配置多个奖品，则用户只需满足不同阶梯之间的差额，即有机会获得对应位置的奖品;</div>
              <div>2、同一位置的奖品，每名用户只能领取一次;</div>
              <div>3、因为每名用户同一位置的奖品限能领取一次，所以在同一位配置几份奖品，即表示能覆盖排行榜几名的位置(例如在位置1共配置了5份奖品A，则表明排行榜前的5名的用户，可获得奖品A);</div>
              <div>4、若出现消费金额相同的情况，将按照参与时间的先后顺序进行排名;</div>
              <div>5、排行榜位置最多可配置5个，每个位置最多可容纳100个用户。</div>
              <div class="newCard">
                <div class="prize_box">
                  <el-form-item label="奖品设置:" required label-width="100px">
                    <div>1、至订单完成后发放奖励，整个活动期内每人每个名次只可领取1次及其中一个奖品。</div>
                    <div>2、奖品展示图片建议尺寸：300*300像素，图片大小不能超过300K，类型：JPG、PNG</div>
                  </el-form-item>
                  <el-table
                    :header-cell-style="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#FAFAFA',
                    }"
                    :cell-style="{ 'text-align': 'center', overflow: 'visible' }"
                    :data="classList"
                    border
                    style="width:1100px;overflow: visible;"
                  >
                    <el-table-column prop="date" label="位置" width="110">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="获奖排名">
                      <template slot-scope="scope">
                        <span>{{getClass(scope)}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="280">
                      <template slot="header" slot-scope="scope">
                        <span>最低入榜条件</span>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            placement="right"
                            :content="ruleForm.rankActivityType==0 ? '配置后，需用户满足当前金额才可进入榜单，例用户消费在榜单中最高，但未达到第一名门槛则不排第一名，根据其余满足门槛的最高名次进行排名' : '配置后，需用户满足当前邀请人数才可进入榜单，例用户在榜单中邀请人数最高，但未达到第一名门槛则不排第一名，根据其余满足门槛的最高名次进行排名'"
                          >
                            <i class="new-icon-box ml4 mt2"></i>
                          </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <div class="flexc-cen-x" v-if="ruleForm.rankActivityType==0">
                          <span>最低消费</span>
                          <el-input class="w120 mlr8" v-model="scope.row.orderAmtLimit" :disabled="activityData.isStart" @input="scope.row.orderAmtLimit = getNumberData(1, $event, 1, 0)" placeholder="不限"></el-input>
                          <span>元</span>
                        </div>
                        <div class="flexc-cen-x" v-else>
                          <span>最低邀请</span>
                          <el-input class="w120 mlr8" v-model="scope.row.successInviteNum" :disabled="activityData.isStart" @input="scope.row.successInviteNum = getNumberData(1, $event, 0, 0)" placeholder="不限"></el-input>
                          <span>人入会</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型" min-width="200px">
                      <template slot-scope="scope">
                        <div>
                          <el-button
                            type="text"
                            v-if="scope.row.prizeType == 3"
                            @click="centerVis2(scope)"
                            style="width:auto"
                            >{{ scope.row.title }}</el-button
                          >
                          <el-button
                            type="text"
                            v-else-if="scope.row.prizeType"
                            :disabled="scope.row.prizeType == 14"
                            @click="centerVis2(scope)"
                            >{{ scope.row.prizeType | prizeType }}</el-button
                          >
                          <el-button
                            v-else
                            @click="centerVis2(scope)"
                            type="text"
                            >选择奖品</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          :disabled="backgroundOpacity || (activityData.isStart && !scope.row.prizeCount) || activityData.isStart"
                          @input="scope.row.prizeCount = getNumberData(1, $event, 0, 1,100),prizeNum(scope.row)"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="logo" width="200" label="奖品展示图片">
                      <template  slot-scope="scope">
                        <div class="btnGroup1">
                          <el-image class="elImg" :src="scope.row.logo" fit="contain" style="width:40px;height: 40px;background: #D9D9D9;border-radius: 4px 4px 4px 4px;margin-right:10px">
                            <div slot="error" class="image-slot"></div>
                          </el-image>
                          <div v-if="backgroundOpacity || activityData.isStart " class="btnGroup">
                            <div style="color: #2768FF;margin-right: 10px;" >上传图片</div>
                            <div style="color: #2768FF;" v-if="scope.row.prizeType != 3 ">重置</div>
                          </div>
                          <div v-else class="btnGroup">
                            <el-upload
                              class="upload"
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :before-upload="beforeUpload3"                     
                              :on-success=" (file) =>  { return handleUpload3(file, scope)}"
                              >
                              <div class="btnGroup_button" style="margin-right: 10px;">上传图片</div>
                            </el-upload>
                            <div class="btnGroup_button" @click="picUrlReset3(scope)" v-if="scope.row.prizeType != 3 ">重置</div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="操作" fixed="right">
                        <template  slot-scope="scope">
                          <el-button @click="deleteClass(scope.$index)" type="text" :disabled="activityData.isStart">删除</el-button>
                          <el-button type="text" style="margin-left: 5px" v-if="activityData.isStart && scope.row.title"
                            @click="itemAddNum('classList',scope.$index)">增加奖品数量</el-button>
                        </template>
                    </el-table-column>
                  </el-table>
                  <el-button
                    type="primary"
                    style="margin-top: 8px;width:auto"
                    @click="addClass"
                  >
                    增加排名（{{ classList.length }}/5）
                  </el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="C端排行榜显示规则:" required >
              <el-radio v-model="ruleForm.showRankType" :label="0" :disabled="activityData.isStart">活动开始后展示</el-radio>
              <el-radio v-model="ruleForm.showRankType" :label="1" :disabled="activityData.isStart">开榜后展示</el-radio>
            </el-form-item>
            <el-form-item label="C端有效金额显示:" required >
              <el-radio v-model="ruleForm.isMistinessAmt" :label="0" :disabled="activityData.isStart">不加密显示</el-radio>
              <el-radio v-model="ruleForm.isMistinessAmt" :label="1" :disabled="activityData.isStart">加密显示</el-radio>
            </el-form-item>

            <div class="newsInfo">额外奖品配置</div>
            <el-form-item label="额外奖品配置:">
              <el-switch
                v-model="isExtraPrizes"
                :disabled="activityData.isStart ? true : false"
                @change="changeIsExtraPrizes"
              ></el-switch>
              开启后可设置额外奖励，活动开始后不可关闭
            </el-form-item>
            <el-form-item label="奖励领取次数:" required v-if="isExtraPrizes">
              <el-radio-group
                v-model="getExtraType"
                :disabled="activityData.isStart ? true : false"
              >
                <el-radio :label="0">仅可领取一次</el-radio>
                <el-radio :label="1">满足条件可领取所有奖品一次</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品设置:" required v-if="isExtraPrizes">
              <el-button type="primary" @click="addExtraPrize" :disabled="activityData.isStart ? true : false" style="width: auto;">+添加奖品（{{extraPrizes.length}}/{{ prizeLimit }}）</el-button>
              <div class="mt16" v-for="(item,index) in extraPrizes" :key="item.createTime">
                <div class="flex-sp">
                  <div>
                    <span>消费门槛：{{ ruleForm.rankActivityType==0 ? '入榜金额' : '成功邀请好友数量' }}≥</span>
                    <el-input class="ml8"  style="width: 150px;" :disabled="activityData.isStart ? true : false" v-model="item.orderAmtLimit" placeholder="请输入"  v-if="ruleForm.rankActivityType==0" @input="
                      item.orderAmtLimit = getNumberData(
                        1,
                        $event,
                        1,
                        0
                      );
                    "
                    @blur="item.orderAmtLimit = validInput($event,index)"
                    ></el-input>
                    <el-input v-else class="ml8" style="width: 150px;" :disabled="activityData.isStart ? true : false" v-model="item.successInviteNum" placeholder="请输入" @input="
                      item.successInviteNum = getNumberData(
                        1,
                        $event,
                        0,
                        0
                      )
                    "
                    @blur="item.successInviteNum = validInput($event,index)"
                    ></el-input>
                    <span class="ml8">{{ ruleForm.rankActivityType==0 ? '元' : '位' }}</span>
                  </div>
                  <i
                    v-if="extraPrizes.length > 1&&!activityData.isStart"
                    class="el-icon-delete delete-icon"
                    @click="deleteExtraPrize(index)"
                  ></i>
                </div>
                <newPrizeTable
                  class="mt16"
                  :prizeList.sync="item.extraPrizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="prizeInfo"
                  :valueRow="valueRow"
                >
                <template #titleHeader>
                  <span style="color: red">*</span>奖品名称（12字内）
                </template>
                <template #dailyLimitNum="{row}">
                  <dailyLimitConfig
                    :row="row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
                </newPrizeTable>
              </div>
            </el-form-item>

            <orderShopInfo v-model="customerPaperwork"/>
            
            <div class="newsInfo">曝光商品</div>
            <el-form-item label="曝光商品:">
              <el-checkbox
                v-model="ruleForm.exposureSwitch"
                @change="exposureSwitchChange"
              >
                是否添加曝光商品
              </el-checkbox>
              <el-button
                style="width: 155px; margin: 0 15px;display: inline-block;"
                :class="[{ add_btn1: ruleForm.exposureSwitch },'zindexBox']"
                @click="exposureProducts"
                :disabled="ruleForm.exposureSwitch == false"
              >
                {{
                  itemListFor.length != ""
                    ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                    : "添加曝光商品"
                }}
              </el-button>
              <el-radio-group
                v-model="ruleForm.radio"
                :disabled="ruleForm.exposureSwitch == false"
              >
                <el-radio :label="0">显示京东价</el-radio>
                <!-- <el-radio :label="1">显示促销价</el-radio> -->
              </el-radio-group>
              <!-- <draggable
              v-if="ruleForm.exposureSwitch == true"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px"
            >
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <div @click.stop="delec(index)" class="delectPosible">
                    <i class="el-icon-circle-close" style="font-size: 16px"></i>
                  </div>
                </div>
              </transition-group>
            </draggable> -->
              <draggable
                v-if="itemListFor.length > 0"
                v-model="mainImagelist"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              >
                <transition-group type="transition">
                  <div
                    v-for="(item, index) in mainImagelist"
                    :key="item.skuId"
                    style="display: inline-block; position: relative"
                    class="show_upImg2"
                  >
                    <img
                      :src="item.logo"
                      width="120px"
                      height="120px"
                      style="display: inline-block"
                    />&nbsp;
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img
                        src="@/assets/thdImg/pages/delet.svg"
                        @click.stop="delec(index)"
                        class="delectIcom"
                      />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <template>
              <div class="newsInfo">分享设置</div>
              <el-form-item label="小程序分享标题:" required label-width="125">
                <el-input
                    type="text"
                    style="width: 400px;margin-left:8px;"
                    show-word-limit
                    v-model="ruleForm.shareTitle"
                    :maxlength="28"
                    :disabled="activityData.isStart"
                  ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享简介:" required label-width="125">
                <el-input
                    type="text"
                    style="width: 400px;margin-left:8px;"
                    show-word-limit
                    v-model="ruleForm.shareIntroduce"
                    :maxlength="28"
                    :disabled="activityData.isStart"
                  ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享图片:" required label-width="130">
                <div class="miniAppPic" style="margin-left:16px;">
                  <div class="top">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload1"
                      :on-success="handleUpload1"
                      >
                      <el-button size="mideal" class="returnBtn"  :disabled="activityData.isStart">自定义上传</el-button>
                    </el-upload>
                    <span class="reset" @click="picUrlReset1">重置</span>
                  </div>
                  <div class="bottom">
                    <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-plus"></i>
                      </div>
                    </el-image>
                    <div class="tips1">
                      <p>建议上传尺寸：200px * 200px</p>
                      <p>图片大小：1MB以内</p>
                      <p>格式：jpg、png</p>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </template>
            <div class="newsInfo">活动规则</div>
            <el-form-item label="规则内容:" required>
              <div
                style="width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 543px"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :maxlength="2000"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{
                    ruleForm.activityRulesText.length
                      ? ruleForm.activityRulesText.length - 1
                      : 0
                  }}/2000）
                </div>
                <div>
                  <el-button
                    type="primary"
                    class="generate"
                    plain
                    @click="generateRule"
                  >
                    生成规则
                  </el-button>

                  <span class="desc">
                    <i class="el-alert__icon el-icon-info"></i>
                    提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                  </span>
                </div>
              </div>
            </el-form-item>
            <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          </template>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button
        v-show="!itemId"
        class="returnBtn createBtn"
        size="medium"
        @click="clickLocalStep()"
      >
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="keepBtn createBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium"
        >保存并完成设置</el-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
    <!-- 指定金额商品 -->
    <selectGoodsMonitor
      ref="appointFilter"
      :isShow="showAppointFilter"
      @close="appointGoodsCloseFilter"
      :selectGoods="appointGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      activityType="36"
      @choose-shop="getTheData"
      :isShowFirst="false"
    >
    </selectProduct>
    <!-- <img src="../../assets/images/new" /> -->
     <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  giftBagEide,
  editShopGift,
  getValidActivity,
  createOrderRank,
  orderRankDetail,
  updateOrderRank,
  publicOpen,
  prefixurl,
  hdTaskTemplateGroup, 
  sellerImage,
} from "@/api/paradiseAndTaskCommonController.js";
import { checkOpenCrmByVenderType } from "@/api/public.js";
import { updateCommon } from "@/api/integralCenter/integralTask";
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";
import addPrizeNum from "./components/add-prize-num.vue";
import dailyLimitConfig from "@/components/dailyLimitConfig.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "京东E卡",
  "爱奇艺会员",
  "京东PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    addPrizeNum,
    dailyLimitConfig,
    newPrizeTable
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    // ...mapState(["venderType"]),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 获取按阶级排名
    getClass(){
      return (scope)=>{
        const count = this.classList.slice(0,scope.$index).reduce((pre,next)=>{
          return pre + Number(next.prizeCount)
        },0)
        // 当前项有值
        if(scope.row.prizeCount){
          if(count > 0){
            if(scope.row.prizeCount == 1){
            return `第${Number(count) + 1}名`
            }else{
              return `第${Number(count) + 1}名~第${Number(count) + Number(scope.row.prizeCount)}名`
            }
          }else{
            if(scope.row.prizeCount == 1){
            return `第1名`
            }else{
              return `第1名~第${scope.row.prizeCount}名`
            }
          }
        }else{
          return ''
        }
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    currentVenderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          // this.qrcodeAll(this.activityData.telCode, queryId);
          // if (this.activityData.id == 13 || this.activityData.id == 14) {
          //   this.getCodeIMG();
          // } else {
          //   this.qrcodeAll(this.activityData.telCode, queryId);
          // }
          this.getCodeIMG();
        });
      }
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },
  },
  data() {
    return {
      extraPrizes: [],
      prizeLimit: 5,
      prizeInfo: [
      {
          label: "奖品类型",
          prop: "prizeType",
          isPrize: true,
          minWidth: 100,
        },
        {
          label: "奖品价值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品图片",
          prop: "logo",
          isPrize: true,
          minWidth: 120,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          isPrize: true,
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          isPrize: true,
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slot: "dailyLimitNum",
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          isPrize: true,
          minWidth: 142,
        },
      ],
      isExtraPrizes: false,
      getExtraType:0,
      customerPaperwork: {},
      venderIds:[],
      sellerSkuList: [],
      isKeyActivity: 0,
      placementPosition: [],
      actEndTime: "",
      orderStartTime: "",
      orderEndTime: "",
      isShowEndTip: false,
      isShowTip: false,
      // 1.14迭代 指定入会时间
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      isNongfu: (this.$store.state.loginUserInfo.venderId == "709005" || this.$store.state.loginUserInfo.venderId == "1000008814" || this.$store.state.loginUserInfo.venderId == "13315956") && this.activityData.id == 16 ? true : false,
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}`,
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList:[],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      templateUItype: 1, //模板类型
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > new Date(this.ruleForm.activityEndime).valueOf()-24*60*60*1000
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      selectGoodsStateFilter: false,
      showAppointFilter: false,
      itemListForFilter: [],
      appointListForFilter: [],
      selectGoodsFilterArr: [],
      includeArr:[],
      excludeArr:[],
      appointGoodsFilterArr: [],
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      // dialogPrize: true,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() >
                new Date(this.ruleForm.activityEndTime).getTime() ||
              time.getTime() < Date.now() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      //开榜时间限制
      scoresOrderStart: {
        disabledDate: (time) => {
          let start = this.ruleForm.activityStartTime ? new Date(this.ruleForm.activityStartTime).getTime()-24*60*60*1000 : 0;
          let end = this.ruleForm.activityEndTime ? new Date(this.ruleForm.activityEndTime).getTime() : Infinity;
          let current = time.getTime();
          if(current > start && current < end){
            return false;
          }else {
            return true;
          }
        },
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) < new Date(this.ruleForm.orderStartTime).getTime() || 
                time.getTime(time)  > new Date(this.ruleForm.orderStartTime).getTime()+ day*100
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.orderStartTime).getTime() || 
                time.getTime(time)  > new Date(this.ruleForm.orderStartTime).getTime()+ day*100
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            const day = 24 * 60 * 60 * 1000;
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime() ||  time.getTime() < new Date(this.ruleForm.orderEndTime).getTime()- day*100
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      ruleForm: {
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        isLimitSkuAmt: false,
        skuStartPayment: "",
        skuEndPayment: "",
        radio: 0,
        startTime:"",
        activityStartTime: null,
        activityEndTime: null,
        prizeSite: "",
        information: [],
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 复购 首单 下单
        condFollow: false, // 是否需要关注店铺
        days: "100", //近X天内未购
        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        showRankTime:"",//开榜时间
        minValidAmount:"",//有效订单金额最小值
        minRankAmount:"",//入榜最低金额
        orderType:[0,1],//订单类型，默认全部勾选
        orderState:0,//订单状态
        moneyCountType:0,//金额统计方式
        refundCountFlag: 0, // 退款回退金额
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        limitAmountType: "0", //限制统计金额：0整单统计 1仅统计指定SKU
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是

        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        showRankType: 0,
        popOrderStartPaymentType: 1,
        isMistinessAmt: 1, //C端有效金额显示
        rankActivityType: 0,
        mergeOrder: false,
      },
      sharePic: "", // 默认分享图
      priceImg:'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/prizeShow.png',//默认产品图
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      orderCRM: false,
      orderCRMtime: "",
      activityUrl: "",
      venderId: "",
      orderStatusList:[
        {
          value: 0,
          label: "付尾款或付款",
        },
        {
          value: 1,
          label: "收货",
        }
      ],
      //奖品设置
      editableTabsValue: '1',
      editableTabs: [{
        title: '第1名',
        name: '1',
        content:[
          {
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
        ],
        orderAmtLimit: "",
        successInviteNum: "",
      }, {
        title: '第2名',
        name: '2',
        content: [
          {
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
        ],
        orderAmtLimit: "",
        successInviteNum: "",
      }],
      copyEditableTabs:[],
      tabIndex: 2,
      rulesType:0,
      classList:[
        {
          title:"",
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
          orderAmtLimit: "",
          successInviteNum: "",
        }
      ],
      isClass:false,
      uploadSize3:false,
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  created() {
    // 数据初始化
    this.init();
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
    console.log(this.activeValue,"this.activeValue",this.activityData)
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      // this.getEdit();
    }
    // 新增-默认活动时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30)[0]
      this.ruleForm.activityEndTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  mounted() {
    this.intiData();
    this.getLevel();
    this.hdTaskTemplateGroup()
    this.$nextTick(() => {
      this.getCodeIMG();
      // this.qrcodeAll(this.activityData.telCode, queryId);
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    // console.log(this.activeValue, 99996);
  },
  methods: {
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    deleteExtraPrize(index) {
      this.extraPrizes.splice(index, 1)
    },
    validInput(val, index) {
      let newVal = val.target.value
      // 如果不是第一行，需要校验是否小于前置排序的值
      if (index > 0 && newVal) {
        const prevItem = this.extraPrizes[index - 1]
        if (!prevItem) return newVal
        
        // 根据活动类型判断校验哪个字段
        if (this.ruleForm.rankActivityType === 0) {
          // 下单冲榜：校验入榜金额
          const prevAmt = prevItem.orderAmtLimit
          if (prevAmt && Number(newVal) <= Number(prevAmt)) {
            this.$message.warning(`第${index + 1}个奖品的入榜金额需大于第${index}个奖品的入榜金额`)
            return ""
          }
        } else {
          // 入会打榜：校验成功邀请好友数量
          const prevNum = prevItem.successInviteNum
          if (prevNum && Number(newVal) <= Number(prevNum)) {
            this.$message.warning(`第${index + 1}个奖品的邀请好友数量需大于第${index}个奖品的邀请好友数量`)
            return ""
          }
        }
      }
      return newVal
    },
    changeIsExtraPrizes() {
      this.getExtraType = 0;
      this.extraPrizes = []
    },
    addExtraPrize() {
      if (this.extraPrizes.length >= this.prizeLimit) {
        this.$message.warning(`最多只能添加${this.prizeLimit}个奖项`);
        return;
      }
      this.extraPrizes.push({
        successInviteNum: "",
        orderAmtLimit: "",
        createTime: new Date().getTime(),
        extraPrizeList: [{
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          discount: "",
        }]
      });
      console.log(this.extraPrizes,'5555');
    },
    intiData() {
      this.venderIds = [this.currentVenderId]
      this.sellerSkuList = [{
        venderId: this.currentVenderId,
        skuIds: []
      }]
    },
     // 改变数量值
    confirmAdd(num) {
      let {toAddBelong,toAddIndex} = this;
      if(toAddBelong == 'classList') {
        this.classList[toAddIndex].prizeCount = num;
      }else {
        this.editableTabs[this.editableTabsValue-1].content[toAddIndex].prizeCount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      if(arrStr == 'classList'){
        this.toAddItem = {
          ...this.classList[index],
          num: this.classList[index].prizeCount
        };
      }else {
        this.toAddItem = {
          ...this.editableTabs[this.editableTabsValue-1].content[index],
          num: this.editableTabs[this.editableTabsValue-1].content[index].prizeCount
        };
      }
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    // 京东计划数量计算
    prizeNum(row){
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if([5,6,7,8,10].includes(Number(row.prizeType))){
        if(Number(row.prizeCount) && (Number(row.prizeCount) > row.budgetRemain)){
          row.prizeCount = ""
          if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    //奖品卡片设置
    handleTabsEdit(targetName, action) {
        if(this.backgroundOpacity || this.activityData.isStart ){ return }
        if (action === 'add') {
          if(this.editableTabs.length < 20){
            console.log("this.editableTabs",this.editableTabs)
            let newTabName = ++this.tabIndex + '';
            this.editableTabs.push({
              title: '第'+ Number(this.editableTabs.length+1) +'名',
              name: newTabName,
              content:[
                {
                  peopleCount: "",
                  prizeType: "",
                  discount: "",
                  prizeCount: "",
                  singleAmount: "",
                },
              ],
              orderAmtLimit: "",
              successInviteNum: "",
            });
            this.editableTabsValue = newTabName;
          }else{
            this.$message.warning('至多添加20个名次')
          }
        }
        if (action === 'remove') {
          if(this.editableTabs.length > 1 ){
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);

          this.editableTabs.forEach((item,index) =>{
            item.title='第'+ Number(index+1) +'名'
          })
        }else{
          this.$message.warning('名次设置需≥1')
        }
      }
    },
    inputprizeCount(scope,index){
      if(this.activityData.isStart){
      console.log("输入",scope.row,scope.$index,index)
      let oldNum = this.copyEditableTabs[index].content[scope.$index].prizeCount
      let now = scope.row.prizeCount
      console.log(Number(oldNum)> Number(now),Number(oldNum),Number(now),this.copyEditableTabs)
      if(Number(oldNum)> Number(now)){
        this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        this.editableTabs[index].content[scope.$index].prizeCount = oldNum
      }
    }
    },
    //上传图片前校验   名次奖品图片设置
    beforeUpload2(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        console.log("宽高",image.width,image.height )
        const valid = (image.width == 300 && image.height == 300)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.warning('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.warning("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  名次奖品图片设置
    handleUpload2(res,scope){
      this.tableIndex = scope.$index;
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          let arr = [...this.editableTabs]
          arr.forEach(item=>{
            if(item.name == this.editableTabsValue){
              item.content[this.tableIndex].logo = res.data;
            }
          })
          this.editableTabs = arr;
        }
      }
    },
    // 重置背景图  名次奖品图片设置
    picUrlReset2(scope){
      this.tableIndex = scope.$index;
      let arr = [...this.editableTabs]
      arr.forEach(item=>{
        if(item.name == this.editableTabsValue){
          item.content[this.tableIndex].logo = this.priceImg;
        }
      })
      this.editableTabs = arr;
    },
    //上传图片前校验   按阶级名次奖品图片设置
    beforeUpload3(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        console.log("宽高",image.width,image.height )
        const valid = (image.width == 300 && image.height == 300)
        file.isFlag = valid
        _this.uploadSize3 = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.warning('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.warning("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  按阶级名次奖品图片设置
    handleUpload3(res,scope){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        if(this.uploadSize3){
          this.$set(scope.row,'logo',res.data)
        }
      }
    },
    // 重置背景图  按阶级名次奖品图片设置
    picUrlReset3(scope){
      this.$set(scope.row,'logo',this.priceImg)
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      if(this.activityData.isStart) return
      this.ruleForm.sharePic = this.sharePic
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate =  Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if(nowDate > startDate){
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      }else{
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);
      
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item,index){
      this.tabActive = index;
      this.navItem = item;
      this.getPolite()
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.getPolite()
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    // 数据初始化
    async init() {
      // const { message: res } = await publicOpen();
      // if (res) {
      //   this.orderCRMtime = res;
      //   this.orderCRM = false;
      // } else {
      if (this.venderType) {
        this.orderCRM = true;
        this.ruleForm.popOrderStartPaymentType  = 1;
      } else {
        this.orderCRM = false;
      }
      let {code: code, message: message, data: data2} = await checkOpenCrmByVenderType();
      console.log(code, message, data2);
      if(code == 1){
        this.orderCRMtime = data2;
      }else {
        if(!!message){
          this.orderCRMtime = "";
          this.$message.warning(message);
          return;
        }else {
          this.orderCRMtime = "";
          this.$message.warning(data2.message);
          return;
        }
      }
      const data = await prefixurl();
      this.activityUrl = data.data.activityUrl;
      this.venderId = data.data.venderId;
    },

   deepClone (obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
          for (var key in obj) {
              if (obj.hasOwnProperty(key)) {
                  //判断ojb子元素是否为对象，如果是，递归复制
                  if (obj[key] && typeof obj[key] === "object") {
                      objClone[key] = this.deepClone(obj[key]);
                  } else {
                      //如果不是，简单复制
                      objClone[key] = obj[key];
                  }
              }
          }
      }
      return objClone;
    },

    // 修改 数据回显
    getEdit() {
      console.log("this.valueRow.id",this.valueRow.id)
      orderRankDetail(this.valueRow.id).then((res) => {
        console.log("res----",res)
        // this.activityTimeValue = [
        //   String(res.data.startTime),
        //   String(res.data.endTime),
        // ];
        // this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        // this.ruleForm.bonusPoints = String(res.data.pointActivityPrizeDTO.price);
        // levelList 不能传-1 回显要回来做对比修改
        if(this.levelList.length == res.data.allowLevel.split(",").length ){
          this.ruleForm.partner = ["-1"]
        }else{
          let level= res.data.allowLevel.split(",")
          let list = []
          level.forEach((low) => {
            this.levelList.forEach(item=>{
              if(item.value == low){
                list.push(item.value)
              } else {
                list.push("-1")
              }
            })
            this.ruleForm.partner = list
          })
          console.log("this.ruleForm.partner",this.ruleForm.partner)
          // 1.14迭代 这里回显
          this.ruleDto = {
            isCheckOpenCardTime:res.data.ruleDto.isCheckOpenCardTime,
            openCardStartTime:res.data.ruleDto.openCardStartTime,
            openCardEndTime:res.data.ruleDto.openCardEndTime,
            plusObject:res.data.ruleDto.plusObject, //plus会员
          }
        }

        if(this.venderType) {
          this.ruleForm.popOrderStartPaymentType  = 1;
        }else {
          this.ruleForm.popOrderStartPaymentType = res.data.ruleDto.popOrderStartPaymentType
          ? res.data.ruleDto.popOrderStartPaymentType
          : 0;
        }
        this.ruleForm.mergeOrder = res.data.ruleDto.mergeOrder || false

        this.ruleForm.condFollow =res.data.condFollow == 1 ? true : false;
        this.templateUItype = res.data.templateJson
          ? JSON.parse(res.data.templateJson).templateUItype
          : 1;
        this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
        this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;
        // 拷贝一份数据做判断
        this.orderStartTime = res.data.ruleDto.orderStartTime;
        this.orderEndTime = res.data.ruleDto.orderEndTime;

        this.ruleForm.orderStartCount = res.data.ruleDto.orderStartCount;
        this.ruleForm.orderEndCount = res.data.ruleDto.orderEndCount;
        this.ruleForm.orderStartPayment = res.data.ruleDto.orderStartPayment;
        this.ruleForm.orderEndPayment = res.data.ruleDto.orderEndPayment;
        this.ruleForm.isLimitSkuAmt = res.data.ruleDto.isLimitSkuAmt;
        this.ruleForm.skuStartPayment = res.data.ruleDto.skuStartPayment;
        this.ruleForm.skuEndPayment = res.data.ruleDto.skuEndPayment;
        this.ruleForm.filterType = String(res.data.ruleDto.skuType);
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.showRankType = String(res.data.ruleDto.showRankType) == 0 ? 0 : 1;
        this.ruleForm.isMistinessAmt = res.data.ruleDto.isMistinessAmt;
        this.ruleForm.showRankTime = res.data.ruleDto.showRankTime;
        this.ruleForm.minValidAmount = res.data.ruleDto.minValidAmount;
        this.ruleForm.minRankAmount = res.data.ruleDto.minRankAmount;


        this.ruleForm.orderType = res.data.ruleDto.orderTypeList;

        this.ruleForm.orderState = res.data.ruleDto.orderState;
        this.ruleForm.refundCountFlag = res.data.ruleDto.refundCountFlag
          ? res.data.ruleDto.refundCountFlag
          : 0;
        this.ruleForm.moneyCountType = res.data.ruleDto.moneyCountType;
        this.ruleForm.limitAmountType = String(res.data.ruleDto.statsMoneyType);
        // 如果接口没有返回，则使用默认值0（整单统计）
        if (this.ruleForm.limitAmountType === undefined || this.ruleForm.limitAmountType === null) {
          this.ruleForm.limitAmountType = "0"; // 0整单统计 1仅统计指定SKU
        }
        // 自定义字段回显
        this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {};

        if (this.ruleForm.isLimitSkuAmt) {
          this.appointListForFilter = res.data.ruleDto.limitSkuList || [];
          this.appointGoodsFilterArr = this.appointListForFilter;
        }
        // 额外奖品
        this.ruleForm.rankActivityType = res.data.ruleDto.rankActivityType;
        this.rankActivityType
        this.isExtraPrizes = res.data.ruleDto.isExtraPrizes ||false;
        this.getExtraType = res.data.ruleDto.getExtraType || 0;
        const list = res.data.ruleDto.extraPrizeList && res.data.ruleDto.extraPrizeList.length? res.data.ruleDto.extraPrizeList : [];
        if(list.length>0){
          list.forEach((item,index)=>{
            this.extraPrizes.push({
              successInviteNum: item.successInviteNum,
              orderAmtLimit: item.orderAmtLimit,
              createTime: new Date().getTime()+index,
              extraPrizeList: [item]
            })
          })
        }
        this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
        //复制 在新活动内除奖品设置、活动规则外，其他信息均回显
        if(!this.activityData.isCopy){
          // 奖品回显---start
          // 按排名
          this.rulesType = res.data.ruleDto.rankType
          if(res.data.prizeDTOList && res.data.prizeDTOList.length){
            if(res.data.ruleDto.rankType == 0){
              this.editableTabs = res.data.prizeDTOList.map(
                (item, index) => {

                  let prizeobj ={
                      title:'第'+Number(index+1)+'名',
                      name:String(Number(index+1)),
                      content:[],
                      orderAmtLimit: item.orderAmtLimit,
                      successInviteNum: item.successInviteNum,
                  };
                  prizeobj.content = item.pointActivityPrizeDTOList.map((item, index) => {
                    let obj = {
                      title: item.title,
                      assetsId: item.assetsId,
                      prizeType: item.prizeType,
                      logo: item.logo,
                      discount: item.price || item.singleAmount,
                      singleAmount: item.singleAmount,
                      price: item.price,
                      prizeCount: item.totalAmount,
                      id:item.id,
                      shouldCollectExtraData: item.shouldCollectExtraData,
                      extraQuestion: item.extraQuestion
                    };
                    if (item.prizeType == 1) {
                      obj.quota = item.quota;
                      obj.couponType = item.couponType;
                    }
                    if(item.prizeType == 14){
                      obj.pointActivityPrizeRemark = item.pointActivityPrizeRemark;
                    }
                    return obj;
                  })
                  return prizeobj
                }
              );
            }else{
              this.classList = res.data.prizeDTOList.map(list=>{
                let obj;
                list.pointActivityPrizeDTOList.forEach(item=>{
                  obj = {
                    title: item.title,
                    assetsId: item.assetsId,
                    prizeType: item.prizeType,
                    logo: item.logo,
                    discount: item.price || item.singleAmount,
                    singleAmount: item.singleAmount,
                    price: item.price,
                    prizeCount: item.totalAmount,
                    id:item.id,
                    shouldCollectExtraData: item.shouldCollectExtraData,
                    extraQuestion: item.extraQuestion,
                    orderAmtLimit: item.orderAmtLimit,
                    successInviteNum: item.successInviteNum,
                  };
                  if (item.prizeType == 1) {
                    obj.quota = item.quota;
                    obj.couponType = item.couponType;
                  }
                  if(item.prizeType == 14){
                    obj.pointActivityPrizeRemark = item.pointActivityPrizeRemark;
                  }
                })
                return obj
              })
            }
          }
          
          //---end
          // 下单多店铺商品处理
          if(res.data.ruleDto.venderIds) {
            this.venderIds = res.data.ruleDto.venderIds;
          }
          if(res.data.ruleDto.sellerSkuList&&res.data.ruleDto.sellerSkuList.length>0) {
            this.sellerSkuList = res.data.ruleDto.sellerSkuList;
            const isReq = this.sellerSkuList.some((item) => {
            return item.venderId == this.currentVenderId&&item.itemList&&item.itemList.length>0;
            });
            if (!isReq) {
            let list =  this.sellerSkuList.filter((item)=>item.venderId == this.currentVenderId)
              const reqList = list.map((item) => {
                return getTaobaoItemListSku({
                  current: 1,
                  size: item.skuIds.length,
                  skuIds: item.skuIds,
                  venderId: item.venderId,
                });
              });
              Promise.all(reqList).then((res) => {
                res.forEach((itemRes, index) => {
                  this.sellerSkuList[index].itemList = itemRes.data.records;
                  this.itemListForFilter = itemRes.data.records
                  if (res.data.ruleDto.skuType == 1) {
                    this.includeArr = this.itemListForFilter
                  } else if(res.data.ruleDto.skuType == 2) {
                    this.excludeArr = this.itemListForFilter;
                  }
                });
              });
            }
          }
          //复制一份出来做比对
          this.copyEditableTabs= []
          this.copyEditableTabs = this.deepClone(this.editableTabs)

          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.activityName = res.data.activityName;
        }else{
          this.sellerSkuList  = [
            {
              skuIds: res.data.ruleDto.sellerSkuList.length>0 ? res.data.ruleDto.sellerSkuList.filter(item=>item.venderId == this.currentVenderId)[0].skuIds : [],
              venderId: this.currentVenderId
            }
          ]
          this.venderIds = [this.currentVenderId]
          this.ruleForm.activityName = res.data.activityName  + ' 复制';
        }
        // 商品
        if(res.data.ruleDto.itemList && res.data.ruleDto.itemList.length){
          // 指定购买商品
          if (res.data.ruleDto.skuType == 1) {
            this.itemListForFilter = res.data.ruleDto.itemList;
            this.includeArr = this.itemListForFilter
          }else if(res.data.ruleDto.skuType == 2) {
            this.itemListForFilter = res.data.ruleDto.itemList;
            this.excludeArr = this.itemListForFilter;
          }
        }
        //曝光商品
        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        this.selectGoodsArr = res.data.itemList;
        this.mainImagelist = res.data.itemList;
        this.itemListFor = res.data.itemList;
        this.activityTimeChange();
      });
    },

    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          this.levelList = []
          res.data.forEach((item) => {
            this.levelList.push(
              { 
                label:item.customerLevelName,
                value:item.customerLevel
              }
            );
          });
          if (this.activeValue) {
            this.getEdit();
          }
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      // const data = await prefixurl();
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = `${this.activityData.telCode}/clientPreview?activityType=${this.activityData.id}&venderId=${data.data.venderId}`;
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = `${this.telCode}&activityType=${this.activityData.id}&templateJson=`;
      const arr = [1, 8, 16, 17, 18, 19, 27, 28]
      if(arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + (arr.includes(Number(this.activityData.id)) ? this.giftList[index].secondImageUrl : JSON.stringify({ templateUItype: this.giftList[index].templateUItype })),
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },

    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    itemDel(index) {
      this.editableTabs.forEach(item=>{
        if(item.name == this.editableTabsValue){
          if (item.content.length == 1) {
            this.$message.warning("必须有一个奖项");
            return;
          }
          item.content.splice(index, 1);
        }
      })
    
    },
    addPrizeRule() {
      this.editableTabs.forEach(item=>{
        if(item.name == this.editableTabsValue){

          if (item.content.length === 4) {
            this.$message.warning("最多可设置4个奖项");
            return;
          }
          item.content.push({
            peopleCount: "",
            prizeType: "",
            value: "",
            prizeCount: "",
          });

        }
      })

    },
    //选择商品数据 曝光
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.showDialog = false;
      if(!this.isClass){
        this.editableTabs.forEach(item=>{
          if(item.name == this.editableTabsValue){
            item.content[this.tableIndex].prizeType = prizeType;
            item.content[this.tableIndex].price =
              data.discount || data.singleAmount;
            item.content[this.tableIndex].singleAmount = data.singleAmount;
            item.content[this.tableIndex].title = data.name || prizeType;
            item.content[this.tableIndex].assetsId = Number(data.couponId);
            item.content[this.tableIndex].logo = data.logo || this.priceImg;
            item.content[this.tableIndex].shouldCollectExtraData = data.shouldCollectExtraData;
            item.content[this.tableIndex].extraQuestion = data.extraQuestion;
            if (prizeType == 1) {
              item.content[this.tableIndex].quota = data.quota;
              item.content[this.tableIndex].couponType = data.couponType;
            }
            if (prizeType == 2) {
              item.content[this.tableIndex].quantityTotal = data.quantityTotal;
            }
            if(prizeType == 3) {
              if(!data.isGoodManage) {
                item.content[this.tableIndex].skuId = data.skuId;
                delete item.content[this.tableIndex].isGoodManage
              } else {
                item.content[this.tableIndex].isGoodManage = data.isGoodManage;
              }
            }
            // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
            if([2,5,6,7,8,10].includes(Number(prizeType))){
              item.content[this.tableIndex].budgetRemain = data.budgetRemain;
            }
            if(prizeType==3&&data.isGoodManage) {
              item.content[this.tableIndex].budgetRemain = data.budgetRemain;
            }
          }
        })
      }else{
        // 按阶梯
        this.classList[this.classIndex].prizeType = prizeType;
        this.classList[this.classIndex].price =
          data.discount || data.singleAmount;
        this.classList[this.classIndex].singleAmount = data.singleAmount;
        this.classList[this.classIndex].title = data.name || prizeType;
        this.classList[this.classIndex].assetsId = Number(data.couponId);
        this.classList[this.classIndex].logo = data.logo || this.priceImg;
        this.classList[this.classIndex].shouldCollectExtraData = data.shouldCollectExtraData;
        this.classList[this.classIndex].extraQuestion = data.extraQuestion;
        if (prizeType == 1) {
          this.classList[this.classIndex].quota = data.quota;
          this.classList[this.classIndex].couponType = data.couponType;
        }
        if (prizeType == 2) {
          this.classList[this.classIndex].quantityTotal = data.quantityTotal;
        }
        if(prizeType == 3) {
          if(!data.isGoodManage) {
            this.classList[this.classIndex].skuId = data.skuId;
            delete this.classList[this.classIndex].isGoodManage
          } else {
            this.classList[this.classIndex].isGoodManage = data.isGoodManage;
          }
        }
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if([2,5,6,7,8,10].includes(Number(prizeType))){
          this.classList[this.classIndex].budgetRemain = data.budgetRemain;
        }
        if(prizeType==3&&data.isGoodManage) {
          this.classList[this.classIndex].budgetRemain = data.budgetRemain;
        }
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //开卡礼包
    nextStepKai(items, templateId = 0) {
      // console.log(items);
      checkOpenCrmByVenderType().then(res => {
        if(res.code == 1){
          this.orderCRMtime = res.data;
        }else {
          this.$message.warning(res.message);
          return;
        }
      }).catch(err => {
        this.$message.error(err);
        return;
      })
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.templateUItype = items.templateUItype;
      if(templateId) {
        this.templateId = templateId
      }
      this.$emit("titopName", this.activityData.name, true);
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    clearScoresTime(){
      this.ruleForm.showRankTime = null;
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      this.isClass = false
      // this.itemArr = this.tableData
      this.editableTabs.forEach(item=>{
        console.log("(item.name",item.name,this.editableTabsValue)
        if(item.name == this.editableTabsValue){
          this.itemArr = item.content
        }
      })
      console.log("this.itemArr",this.itemArr)
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (this.itemArr[scope.$index].prizeType == 3) {
        this.clickActual = true;
      }
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 按阶梯选择奖品类型
    centerVis2(scope) {
      this.isClass = true
      this.classIndex = scope.$index
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart =
      //   this.ruleForm.activityStartTime &&
      //   this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd =
      //   this.ruleForm.activityEndTime &&
      //   this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      console.log(this.venderType,'545454554545454');
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云起云舟】合作有效期。");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }

      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (val&&end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (val&&end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 清除时间
    cleanActivityTime(){
      // this.activityTimeValue = [];
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //开榜时间
    scoresChange() {
      let start = new Date(this.ruleForm.scoresStartTime).valueOf();
      let end = new Date(this.ruleForm.scoresEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.scoresStartTime &&
        this.ruleForm.scoresStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.scoresEndTime &&
        this.ruleForm.scoresEndTime.substring(0, 10);
      if (this.ruleForm.scoresStartTime && this.ruleForm.scoresEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("时间最大范围为近1年");
          this.ruleForm.scoresEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("开始时间不能大于结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 点击下单时间显示提示
    orderFocus(type) {
      if(this.activityData.isStart) {
        if(type==1) {
          this.isShowEndTip = true
        } else {
          this.isShowTip = true
        }
      }
    },
    // 规则判断
    changDays() {
      if (Number(this.ruleForm.days) > 100) {
        this.$message.warning("范围为1-100天!");
        this.ruleForm.days = "";
      }
      if (
        this.ruleForm.orderStartCount &&
        this.ruleForm.orderEndCount &&
        Number(this.ruleForm.orderStartCount) >=
          Number(this.ruleForm.orderEndCount)
      ) {
        this.$message.warning("商品结束件数要大于商品开始件数!");
        this.ruleForm.orderEndCount = "";
      }
      if (
        this.ruleForm.orderStartPayment &&
        this.ruleForm.orderEndPayment &&
        Number(this.ruleForm.orderStartPayment) >=
          Number(this.ruleForm.orderEndPayment)
      ) {
        this.$message.warning("订单结束金额要大于订单开始金额!");
        this.ruleForm.orderEndPayment = "";
      }
    },
    skuPaymentChange() {
      if (
        this.ruleForm.skuStartPayment &&
        this.ruleForm.skuEndPayment &&
        Number(this.ruleForm.skuStartPayment) >=
          Number(this.ruleForm.skuEndPayment)
      ) {
        this.$message.warning("指定商品结束金额要大于指定商品开始金额！");
        this.ruleForm.skuEndPayment = "";
      }
    },
    // 返回上一步
    returnBack() {
      // this.$emit("returnBack");
      if (this.valueRow && this.valueRow.id && !this.activityData.isCopy) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      let nowTime = new Date().getTime();
      if(new Date(this.ruleForm.activityEndTime).getTime()<nowTime) {
       return this.$message.warning("结束时间不能小于当前时间");
      }
      if(this.isExtraPrizes) {
        if(this.extraPrizes.length==0) {
          return this.$message.warning("请设置额外奖品！");
        }
        const flagStatus =  this.extraPrizes.some((item) => {
          return this.ruleForm.rankActivityType==0&&!item.orderAmtLimit
        })
        if(flagStatus) {
          return this.$message.warning("请填写额外奖品的消费门槛！");
        }
        const flagStatus1 =  this.extraPrizes.some((item) => {
          return this.ruleForm.rankActivityType==1&&!item.successInviteNum
        })
        if(flagStatus1) {
          return this.$message.warning("请填写额外奖品的邀请人数门槛！");
        }
        
        
        const isTrue = this.extraPrizes.some((item) => {
          return item.extraPrizeList.some((item) => !item.prizeType || !item.title || !item.totalAmount)
        })
        if(isTrue) {
          return this.$message.warning("请完善额外奖品信息！");
        }
      }
      if(!this.useValidateMoreActSet(this)) {
        return;
      }
      // console.log(this.itemArrOne);
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
        // 指定商品处理
        if(this.sellerSkuList.length>0&&this.ruleForm.filterType!=0) {
          this.sellerSkuList.forEach((item) => {
            if(item.venderId==this.currentVenderId) {
              item.skuIds = this.itemListForFilter.map((item) => item.skuId)
            }
          })
        }
      let cardParams = {
        templateJson: JSON.stringify({
          templateUItype: this.templateUItype,
        }),
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        // allowLevel:this.ruleForm.partner[0] == -1 ? this.levelList.join(",") : this.ruleForm.partner.join(","), //参与会员等级：填会员等级, 全部不能填-1
        condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺

        // 1.14迭代 这里提交~
        ruleDTO: {
          isCheckOpenCardTime:this.ruleDto.isCheckOpenCardTime,
          openCardStartTime:this.ruleDto.openCardStartTime,
          openCardEndTime:this.ruleDto.openCardEndTime,
          plusObject:this.ruleDto.plusObject, //plus会员
          // subType: this.activityData.id, //活动类型  16: 下单有礼 17: 首单专享礼 18:复购有礼
          // days: this.ruleForm.days, //近X天内未购
          orderStartTime: this.ruleForm.orderStartTime,
          orderEndTime: this.ruleForm.orderEndTime,
          
          popOrderStartPaymentType:this.ruleForm.popOrderStartPaymentType,

          // orderStartCount: this.ruleForm.orderStartCount,
          // orderEndCount: this.ruleForm.orderEndCount,
          // orderStartPayment: this.ruleForm.orderStartPayment,
          // orderEndPayment: this.ruleForm.orderEndPayment,

          //限制金额统计
          statsMoneyType: this.ruleForm.limitAmountType, //限制金额统计 0 不统计 1 统计
   

          showRankTime:this.ruleForm.showRankTime, // 开榜时间
          minValidAmount:this.ruleForm.minValidAmount,//有效订单金额最小值
          minRankAmount:this.ruleForm.minRankAmount,//入榜最低金额（元）
          orderTypeList:this.ruleForm.orderType,//订单类型 0预售订单 1普通订单
          orderState:this.ruleForm.orderState,
          refundCountFlag: this.ruleForm.refundCountFlag,
          moneyCountType:this.ruleForm.moneyCountType,

          skuType: this.ruleForm.filterType,
          // skuIdList: this.itemListForFilter.map((item) => item.skuId),
          // skuIds: this.itemListForFilter.map((item) => item.skuId),
          skuIds: [],
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          showRankType: this.ruleForm.showRankType,
          rankType:this.rulesType,
          isMistinessAmt: this.ruleForm.isMistinessAmt, // C端有效金额显示
          customRankType: 0, // 打榜类型：null/0-默认排行榜,1自定义排行榜
          // 兼容云舟下单多店铺
          venderIds: this.venderIds,
          sellerSkuList: this.sellerSkuList,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
          isExtraPrizes: this.isExtraPrizes,
          getExtraType: this.getExtraType,
          extraPrizeList: this.extraPrizes.map((item)=>{
            return {
              prizeObjectType: 1,
              ...item.extraPrizeList[0],
              orderAmtLimit: item.orderAmtLimit,
              successInviteNum: item.successInviteNum,
            }
          }),
          mergeOrder: this.ruleForm.mergeOrder,
        }, //活动名称        
        prizeDTOList:[],//奖品列表
        itemList: this.itemListFor, //曝光商品集合
        points: 10,
        templateId: this.templateId,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };

      //会员等级设置
      let list=[]
      this.ruleForm.partner.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
          this.levelList.forEach(item=>{
            list.push(item.value)
          })
          cardParams.allowLevel= list.join(",")
        }else{
          this.levelList.forEach(item=>{
            if(item.value == low){
              list.push(item.value)
            }
          })
          cardParams.allowLevel= list.join(",")
        }
      });

      // editableTabs
      // 名次奖品设置
      if(this.rulesType == 0){
        cardParams.prizeDTOList = this.editableTabs.map((item,index) => {
          let prizeList ={
            taskIndex:Number(index+1),
            pointActivityPrizeDTOList:[],
            orderAmtLimit: item.orderAmtLimit,
            successInviteNum: item.successInviteNum,
          };
          prizeList.pointActivityPrizeDTOList = item.content.map((item) => {
            // 按排名奖品数量固定为1
            if(!item.prizeCount){
              item.prizeCount = 1
            }
            let prize = {
              title: item.title,
              assetsId: item.assetsId,
              prizeType: item.prizeType,
              singleAmount: item.singleAmount, //
              totalAmount: item.prizeCount, // 总数额
              price: item.price,
              logo:item.logo,
              id:item.id,
              shouldCollectExtraData: item.shouldCollectExtraData,
              extraQuestion: item.extraQuestion
            };
            if (prize.prizeType == 3) {
              prize.logo = item.logo;
              prize.assetsId = item.skuId || item.assetsId;
              if(item.isGoodManage==1) {
                prize.isGoodManage = item.isGoodManage
              }
            }
            if (prize.prizeType == 1) {
              prize.quota = item.quota;
              prize.couponType = item.couponType;
            }

            if (prize.prizeType == 2 || prize.prizeType == 4) {
              prize.singleAmount = item.price;
            } else {
              prize.singleAmount = 1;
            }
            // if (prize.prizeType != 2 && prize.prizeType != 4) {
            // if (prize.prizeType != 1 && prize.prizeType != 3) {
            //   console.log(item.discount);
            //   prize.price = item.price;
            // }
            return prize;
          });
          return prizeList
        });
      }else{
        // 按阶梯
        cardParams.prizeDTOList = this.classList.map((item,index)=>{
          const obj = {
            taskIndex:Number(index+1),
            pointActivityPrizeDTOList:[],
            orderAmtLimit: item.orderAmtLimit,
            successInviteNum: item.successInviteNum,
          }
          let prize = {
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.prizeCount, // 总数额
            price: item.price,
            logo:item.logo,
            id:item.id,
            shouldCollectExtraData: item.shouldCollectExtraData,
            extraQuestion: item.extraQuestion
          };
          if (prize.prizeType == 3) {
            prize.logo = item.logo;
            prize.assetsId = item.skuId || item.assetsId;
            if(item.isGoodManage==1) {
              prize.isGoodManage = item.isGoodManage
            }
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }
          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
          } else {
            prize.singleAmount = 1;
          }
          obj.pointActivityPrizeDTOList.push(prize)
          return obj
        })
      }

      //修改中的名次奖品设置
      let prizes = []
      // this.editableTabs.forEach((list,index) => {
      //   list.content.forEach((item) => {
      //     console.log("id",item,22334,item.prizeCount)
      //     let prize={
      //       prizeId:item.id,
      //       totalAmount:item.prizeCount
      //     }
      //     prizes.push(prize)
      //   });
      // });
      cardParams.prizeDTOList.forEach((list,index) => {
        console.log('list>>',list)
        list.pointActivityPrizeDTOList.forEach((item) => {
          console.log("id",item,22334,item.prizeCount)
          let prize={
            prizeId:item.id,
            totalAmount:item.totalAmount
          }
          prizes.push(prize)
        });
      });
      
      console.log(cardParams,'活动配置');
      // console.log(this.tableData);
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
      }
      
      if(!this.isDraft){
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }

        //活动参与对象限制
        console.log("this.ruleForm.partner",this.ruleForm.partner)
        if (!this.ruleForm.partner || this.ruleForm.partner.length == 0) {
          this.$message.warning("请选择活动参与对象");
          return;
        }

        // 1.14迭代 这里判断
        if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
          return this.$message.warning("请选择入会时间");
        }

        //下单时间不能为空
        if (!this.ruleForm.showRankTime) {
          this.$message.warning("请填写开榜时间！");
          return;
        }
        if(new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.showRankTime).getTime() <= 3600000){
          return this.$message.warning("开榜时间需早于结束时间1小时");
        }

        //下单时间不能为空
        if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
          this.$message.warning("请填写下单时间！");
          return;
        }
        if(new Date(this.ruleForm.showRankTime).getTime() - new Date(this.ruleForm.orderEndTime).getTime() <= 3600000){
          return this.$message.warning("下单结束时间需早于开榜时间1小时");
        }
        console.log(new Date(this.ruleForm.orderEndTime).getTime() - new Date(this.ruleForm.showRankTime).getTime());
        
        //有效订单金额最小值不能为空
        if (!this.ruleForm.minValidAmount) {
          this.$message.warning("请填写有效订单金额最小值！");
          return;
        }

        //入榜最低金额不能为空
        if (!this.ruleForm.minRankAmount) {
          this.$message.warning("请填写入榜最低金额！");
          return;
        }

        //订单类型不能为空
        if (  !this.ruleForm.orderType ||
          this.ruleForm.orderType.length == 0) {
          this.$message.warning("请填写订单类型！");
          return;
        }
        
        //订单类型不能为空
        if (  !this.ruleForm.orderType ||
          this.ruleForm.orderType.length == 0) {
          this.$message.warning("请填写订单类型！");
          return;
        }

        //orderStatus订单状态不能为空
        if (  !this.ruleForm.orderState && this.ruleForm.orderState != 0 ) {
          this.$message.warning("请填写订单状态！");
          return;
        }
        
        if (this.ruleForm.filterType == 1) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加指定商品！");
            return;
          }
        }else if (this.ruleForm.filterType == 2) {
          if (this.itemListForFilter.length == 0) {
            this.$message.warning("请添加排除商品！");
            return;
          }
        }
        // 请将奖品填写完整！
        let isFlay = false;
        let commonList = []
        // 按排名
        if(this.rulesType == 0){
          this.editableTabs.map((item,index) => {
            item.content.forEach((item) => {
              if (!item.price || !item.prizeCount) {
                isFlay = true;
              }
            });
          })
          commonList = this.editableTabs;
        }else{
        // 按阶梯
          this.classList.forEach((item) => {
            if (!item.price || !item.prizeCount) {
              isFlay = true;
            }
          });
          commonList = this.classList;
        }
        
        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
        // 最低入榜条件校验（支持按排名和按阶梯两种模式）
        if (this.ruleForm.rankActivityType == 0) {
            // 下单冲榜校验
            const minRankAmount = Number(this.ruleForm.minRankAmount) || 0;
            for (let i = 0; i < commonList.length; i++) {
              const item = commonList[i];
              const currentVal = Number(item.orderAmtLimit);
              // 校验是否小于全局入榜最低金额
              if (item.orderAmtLimit != "" && currentVal < minRankAmount) {
                this.$message.warning("最低入榜条件不得小于入榜最低金额");
                return;
              }
              // 从第二名开始校验与前一名的关系：后一名条件必须小于前一名
              if (i > 0 && item.orderAmtLimit !== "") {
                const prevItem = commonList[i - 1];
                const prevVal = Number(prevItem.orderAmtLimit);
                if (prevItem.orderAmtLimit == "" || currentVal > prevVal) {
                  this.$message.warning("最低入榜条件不得小于排名靠前的");
                  return;
                }
              }
            }
        } else {
          // 入会打榜校验
          const inviteLimit = Number(this.openCardRule.inviteLimit) || 0;
          for (let i = 0; i < commonList.length; i++) {
            const item = commonList[i];
            const currentVal = Number(item.successInviteNum);
            // 校验是否小于全局入榜最低邀请人数
            if (item.successInviteNum != "" && currentVal < inviteLimit) {
              this.$message.warning("最低入榜条件不得小于入榜最低邀请人数");
              return;
            }
            // 从第二名开始校验与前一名的关系：后一名条件必须小于前一名
            if (i > 0 && item.successInviteNum != "") {
              const prevItem = commonList[i - 1];
              const prevVal = Number(prevItem.successInviteNum);
              if (prevItem.successInviteNum == "" || currentVal > prevVal) {
                this.$message.warning("最低入榜条件不得小于排名靠前的");
                return;
              }
            }
          }
        }

        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
        // 请选择广告位
        if (this.placementPosition.length == 0) {
          this.$message.warning("请选择活动投放位置");
          return;
        }
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
          if(this.activityData.isStart){
            let params = {
              activityId: this.valueRow.id,
              // endTime: cardParams.endTime,
              ruleDescription: cardParams.ruleDescription,
              prizes: prizes,
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              ruleDTO: cardParams.ruleDTO,
            }
            if(this.orderStartTime!=this.ruleForm.orderStartTime||this.orderEndTime!=this.ruleForm.orderEndTime) {
              params.ruleDTO = cardParams.ruleDTO
            }
            if(this.actEndTime!=this.ruleForm.activityEndTime) {
              params.endTime = this.ruleForm.activityEndTime
            }
            updateCommon(params).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              } else {
                this.$message.error(res.message);
              }
            });
          }else{
            updateOrderRank({
              ...cardParams,
              pointActivityId: this.valueRow.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          if(this.isDraft){
            cardParams.status = 5
            // 草稿箱奖品填写完整校验-若不全则为空
            cardParams.prizeDTOList = cardParams.prizeDTOList.map(list=>{
              list.pointActivityPrizeDTOList = list.pointActivityPrizeDTOList.filter(item=>item.prizeType)
              return list
            })
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            cardParams.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete cardParams.id
          }
          createOrderRank(cardParams).then((res) => {
            if (res.code == 1) {
              if(this.isDraft){
                this.$message.success("保存成功！")
                this.$emit("returnBack",true);
              }else{
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "活动领奖限制：整个活动期内获奖用户只可领取对应中奖名次中的1个奖品",
        text8 = "",
        test1 = "",
        test2 = "",
        test3 = "",
        test4 = "",
        test5 = "",
        test6 = "",
        test7 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName+ ";" + "\n";
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 =
          "活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime+ ";" + "\n";
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it.label;
              }
            });
          }
          levelText.push(item);
        });
        text3 = "活动参与对象：" + levelText.splice(",")+ ";" + "\n";
      }

      //活动条件
      // if (this.ruleForm.condFollow) {
      //   text4 = "活动条件：" + "已关注店铺，可参与活动";
      // }

      // 参与规则
      // 下单时间
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        test1 =
          "下单时间：" +
          this.ruleForm.orderStartTime +
          "~" +
          this.ruleForm.orderEndTime + ";" + "\n";
      }
      //有效订单金额最小值
      if (this.ruleForm.minValidAmount) {
        test2 = "有效订单金额最小值：" + this.ruleForm.minValidAmount +"元" + ";" + "\n"
      }
      //入榜最低金额
      if (this.ruleForm.minRankAmount) {
        test3 = "入榜最低金额：" + this.ruleForm.minRankAmount +"元"+ ";" + "\n"
      }
      //订单类型
      if (this.ruleForm.orderType.length > 0) {
        let typeText = [];
        this.ruleForm.orderType.forEach((item, index) => {
          if(item == 1){
            typeText.push('普通订单')
          }else{
            typeText.push('预售订单')
          }
          
        });
        test4 = "订单类型：" + typeText.splice(",") + ";" + "\n";
      }
      //订单状态
      if (this.ruleForm.orderState) {
        let status = ""
        if (this.ruleForm.orderState == 0) {
          status = "付尾款或付款" ;
        }
        if (this.ruleForm.orderState == 1) {
          status = "收货" ;
        }
        test5 = "订单状态：" + status + ";" + "\n"
      }

      //指定购买商品
      if (this.ruleForm.filterType) {
        let filter = ""
        if (this.ruleForm.filterType == 1) {
          filter  = "指定商品" ;
        }else if(this.ruleForm.filterType == 2) {
          filter  = "排除商品" ;
        }else{
          filter  = "全部商品" ;
        }
        test6 = "指定购买商品：" + filter  + ";" + "\n";
      }

      
      //金额统计方式
      if (this.ruleForm.moneyCountType == 0 || this.ruleForm.moneyCountType == 1) {
        let statis = ""
        if (this.ruleForm.moneyCountType == 1) {
          statis  = "单笔订单" ;
        }else{
          statis  = "累计订单" ;
        }
        test7 = "金额统计方式：" + statis + ";" + "\n";
      }
      
      text6 = '参与规则：'+ "\n" + test1  + test2 + test3+ test4 + test5 + test6 + test7;

      //奖品设置
      let text9 = "活动奖品："+ "\n";

      // 按阶梯
      if(this.rulesType == 1){
        this.classList.forEach((item,index)=>{
          const count = this.classList.slice(0,index).reduce((pre,next)=>{
            return pre + Number(next.prizeCount)
          },0)
          // 当前项有值
          if(item.prizeCount){
            if(count > 0){
              if(item.prizeCount == 1){
              text9 += `第${Number(count) + 1}名: ${item.price}${this.$options.filters.prizeType(item.prizeType)}` + "\n"
              }else{
                text9 += `第${Number(count) + 1}名~第${Number(count) + Number(item.prizeCount)}名: ${item.price}${this.$options.filters.prizeType(item.prizeType)}` + "\n"
              }
            }else{
              if(item.prizeCount == 1){
              text9 += `第1名: ${item.price}${this.$options.filters.prizeType(item.prizeType)}` + "\n"
              }else{
                text9 += `第1名~第${item.prizeCount}名: ${item.price}${this.$options.filters.prizeType(item.prizeType)}` + "\n"
              }
            }
          }
        })
      }else{
        this.editableTabs.forEach((item,num)=>{
          text9 += '第'+Number(num+1)+'名:';
          item.content.forEach((item, index) => {
              console.log("111",item)
            let result = "";
            if (item.prizeType == "1") {
              result = item.price + "元优惠券";
            } else if (item.prizeType == "2") {
              result = item.price + "京豆";
            } else if (item.prizeType == "3") {
              result = item.price + "元#" + item.title;
            } else if (item.prizeType == "4") {
              result = item.price + "店铺积分";
            } else if (item.prizeType == "5") {
              result = item.price + "元京东E卡";
            } else if (item.prizeType == "6") {
              result = item.price + "元爱奇艺会员";
            } else if (item.prizeType == "7") {
              result = item.price + "元京东PLUS会员";
            } else if (item.prizeType == "8") {
              result = item.price + "元现金红包";
            } else if (item.prizeType == "10") {
              result = item.price + "张礼品卡";
            }
            // if (item.price && item.prizeCount) {
              text9 += `${index + 1}) ${result}`;
            // }
          });
          text9 += "\n";
        }) 
      }

      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(v.informationmationOne);
      });
      levetListTwo = levetListOne.join(",");
      levetListThree = levetList.join(",");
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }

      let plusText = ''
      // 1.14迭代 plus会员
      if(this.ruleDto.plusObject!=0){
        plusText =  `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      }else{
        plusText =  `Plus会员身份：不限` + ";" + "\n";
      }
      
      let Arr1 = [text1, text2, text3, plusText, text5, text6, text9, text7];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item ;
          newNum = newNum + 1;
        }
      });
      
      // // 1.14迭代 plus会员
      // if(this.ruleDto.plusObject!=0){
      //   newText = newText + newNum + "." + `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      // }else{
      //   newText = newText + newNum + "." + `Plus会员身份：不限` + ";" + "\n";
      // }

      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    testParmasSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      // 根据类型显示商品
      if(val == 1){
        this.selectGoodsFilterArr = this.includeArr
        this.itemListForFilter = this.includeArr
      }else if(val == 2){
        this.selectGoodsFilterArr = this.excludeArr
        this.itemListForFilter = this.excludeArr
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        // this.mainImagelist = [];
      }
      // 根据类型显示商品
      if(this.ruleForm.filterType == 1){
        this.selectGoodsFilterArr = this.includeArr
        this.itemListForFilter = this.includeArr
      }else if(this.ruleForm.filterType == 2){
        this.selectGoodsFilterArr = this.excludeArr
        this.itemListForFilter = this.excludeArr
      }
      console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },

    // 指定金额商品
    appointProductsFiter() {
      this.showAppointFilter = true;
      if (this.appointListForFilter.length == 0) {
        this.appointListForFilter = [];
        this.appointGoodsFilterArr = [];
      }
      this.$refs.appointFilter.handleRightCurrentChange(1);
    },

    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        console.log(data);
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          // this.mainImagelist.push(fomeVaule);
        });
        if(this.ruleForm.filterType == 1){
          this.includeArr = this.itemListForFilter;
        }else if(this.ruleForm.filterType == 2){
          this.excludeArr = this.itemListForFilter
        }
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },

    appointGoodsCloseFilter(data) {
      if (data) {
        this.appointListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.appointListForFilter.push(fomeVaule);
        });
        this.appointGoodsFilterArr = this.appointListForFilter;
      }
      this.showAppointFilter = false;
    },

    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.prizeCount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.error("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      // e.target.value = Number(filtered);
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },

    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = ""; //活动类型  13: 开卡礼包 14: 店铺礼包
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.appointGoodsFilterArr = [];
      this.appointListForFilter = [];
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.ruleForm.days = "100"; //近X天内未购
      this.ruleForm.orderStartTime = ""; //下单开始时间
      this.ruleForm.orderEndTime = ""; //下单结束时间
      this.ruleForm.orderStartCount = ""; //订单开始笔数
      this.ruleForm.orderEndCount = ""; //订单结束笔数
      this.ruleForm.orderStartPayment = ""; //订单开始金额
      this.ruleForm.orderEndPayment = ""; //订单结束金额
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      this.ruleForm.isLimitSkuAmt = false; // 是否选择指定商品金额
      this.ruleForm.skuStartPayment = ""; // 指定商品结开始金额
      this.ruleForm.skuEndPayment = ""; // 指定商品结束金额
      this.tableData = [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ];
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    // 按阶级新增
    addClass(){
      if (this.classList.length === 5) {
        this.$message.warning("最多可设置5个阶梯区间");
        return;
      }
      this.classList.push({
        title:"",
        peopleCount: "",
        prizeType: "",
        discount: "",
        prizeCount: "",
        singleAmount: "",
        orderAmtLimit: "",
        successInviteNum: "",
      })
    },
    // 按阶级删除
    deleteClass(index){
      this.classList.splice(index,1)
    }
  },
};
</script>

<style lang="scss">
.oneOrder-tooltip{
  max-width: 350px;
}
</style>

<style lang="scss" scoped>
.oneOrder{
  margin-right: 0px;
}
.condition {
  font-weight: 700;
  margin-left: 20px;
}

.nong_fu_icon {
  margin-left: 4px;
  padding-top: 2px;
  cursor: pointer;

  .tips {
    display: none;
  }

  &:hover {
    .tips {
      color: red;
      font-size: 14px;
      display: inline-block;
      margin-left: 12px;
    }
  }
}

.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #7b61ff;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.btnGroup{
  display: flex;
  justify-content: space-around;
  align-items: center;
  &_button{
    color: rgb(123, 97, 255);
    cursor: pointer;
  }
}
.btnGroup1{
  display: flex;
  align-items: center;
}
.del_box {
  position: absolute;
  left: 150px;
  top: 65%;
  transform: translate(0, -50%);
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 1000px;
  // height: 217px;
  background: #fafafa;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.active-width {
  width: 1300px;
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #7b61ff;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #7b61ff;
    border: 1px solid #7b61ff;
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(123, 97, 255, 0.1);
    border-radius: 4px;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #7b61ff;
                border-bottom: 1px solid #7b61ff;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #7b61ff;
                border-left: 1px solid #7b61ff;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#7B61FF;
      background: rgba(123,97,255,0.1);
      border: 1px solid #7B61FF;
      &:hover{
        color: #fff;
        background: #7B61FF;
      }
    }
    .reset{
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.newCard{
  width: 1100px;
  margin: 20px 0 0 0;
  /deep/.el-tabs__header{
    margin:0
  }
  /deep/.el-tabs__content{
  border: 1px solid #d3dce6;
    border-top: 0;
  }
  /deep/.el-tabs__new-tab{
    color:#7B61FF;
    border:1px solid #7B61FF;
    width: 25px;
    height:25px;
    margin: 8px 0 0 0;
    line-height: 25px;
    font-size: 18px;
  }
}

.flex-sp {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.delete-icon {
  font-size: 18px;
  cursor: pointer;
  &:hover {
    color: #ff4d4f;
  }
}

.ml8 {
  margin-left: 8px;
}
.mt16 {
  margin-top: 16px;
}

.w120 {
  width: 120px;
}
.mlr8 {
  margin: 0 8px;
}

.flexc-cen-x {
  display: flex;
  align-items: center;
}

</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7b61ff;
  //   border-color: #7b61ff;
  //   .el-step__line {
  //     background-color: #7b61ff;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7b61ff;
  //   border-color: #7b61ff;
  // }
  // .el-step__title.is-process {
  //   color: #7b61ff;
  // }
  // .el-step__title.is-success {
  //   color: #7b61ff;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}

.ml12 {
  margin-left: 12px;
}

</style>
